import { render, staticRenderFns } from "./ListGasbotStatisticsView.vue?vue&type=template&id=0893ade1&scoped=true"
import script from "./ListGasbotStatisticsView.vue?vue&type=script&lang=ts"
export * from "./ListGasbotStatisticsView.vue?vue&type=script&lang=ts"
import style0 from "./ListGasbotStatisticsView.vue?vue&type=style&index=0&id=0893ade1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893ade1",
  null
  
)

export default component.exports